export interface GlanceCardViewDataModel {
  name: string;
  avatarURL: string;
  locationText: string;
  thirdTextLabel: string;
  thirdText: string;
  fourthTextLabel: string;
  fourthText: string;
  fifthTextLabel: string;
  fifthText: string;
  sixthTextLabel: string;
  sixthText: string;
  isExpanded: boolean;
  enableExpand: boolean;
  hideLocation?: boolean;
  lastInteraction?: { label: string; detail: string };
  buttons:Array<{
    id:string;
    imgSrc?: string;
    name?:string;
    icon?:string;
    iconName?:string;
    isDisabled:boolean;
  }>;
}

/** A OneKey record is not in the CRM yet: name only, no actions or attributes to offer. */
export function oneKeyGlanceViewData(name: string): GlanceCardViewDataModel {
  return {
    name, avatarURL: '', locationText: '', hideLocation: true,
    thirdTextLabel: '', thirdText: '', fourthTextLabel: '', fourthText: '',
    fifthTextLabel: '', fifthText: '', sixthTextLabel: '', sixthText: '',
    isExpanded: true, enableExpand: false, buttons: [],
  };
}
